import React, { useContext, FC } from 'react';
import { TGDPRConsentField } from '../../types/gdprConsentField.types';
import GDPRCheckbox from './components/checkbox';
import GDPRPopup from './components/popup';
import { GDPR, NO_GDPR } from '../../../../constants/gdpr.constants';
import { GenericPopUpContext } from '../../../@shared/genericPopUpContextProvider';
import GdprInlineConsent from './components/gdprInlineConsent';

const GdprConsentField: FC<TGDPRConsentField> = (props) => {
  const consentType = props?.field?.model?.stringifiedConsentType;
  const context = useContext(GenericPopUpContext);

  if (props.field.model.gdprPolicies && consentType === GDPR) {
    if (context?.isGenericPopUp) {
      return <GdprInlineConsent {...props} />;
    }
    return <GDPRPopup {...props} />;
  } else if (consentType === NO_GDPR) {
    return <GDPRCheckbox {...props} />;
  } else {
    return null;
  }
};

export default GdprConsentField;
